import axios from "@/axios/axios";
import {TreenodeDocument} from "@/interfaces/treenode.interfaces";
import {ProjectDocument} from "@/interfaces/project.interfaces";

/**
 * Copy project data
 * @param fromPrj Existing project ID
 * @return Promise of ProjectDocument which is the new project
 */
export async function copyProject(fromPrj: string): Promise<ProjectDocument | null> {
  try {
    const result = await axios.post(`/prj/copy/${fromPrj}`)
    return result ? result.data : null
  } catch (e) {
    console.log('copyProject failed :', e)
    return null
  }
}

/**
 * Copy tree nodes of an existing project
 * @param fromPrj Existing project ID
 * @param toPrj New project ID
 * @return Promise of TreenodeDocument[] which are the new project tree nodes
 */
export async function copyTreeNodes(fromPrj: string, toPrj: string): Promise<TreenodeDocument[]> {
  try {
    const result = await axios.post(`/tnode/copy/${fromPrj}/${toPrj}`)
    return result ? result.data : []
  } catch (e) {
    console.log('copyTreeNodes failed :', e)
    return []
  }
}

export async function copyReleases(fromPrj: string, toPrj: string) {
  try {
    const result = await axios.post(`/release/copy/${fromPrj}/${toPrj}`)
    return result ? result.data : []
  } catch (e) {
    console.log('copyReleases failed :', e)
    return []
  }
}

export async function copyVariables(fromPrj: string, toPrj: string) {
  try {
    const result = await axios.post(`/variable/copy/${fromPrj}/${toPrj}`)
    return result ? result.data : []
  } catch (e) {
    console.log('copyTreeNodes failed :', e)
    return []
  }
}

export async function copyScreens(fromPrj: string, toPrj: string) {
  try {
    const result = await axios.post(`/screen/copy/${fromPrj}/${toPrj}`)
    return result ? result.data : []
  } catch (e) {
    console.log('copyScreens failed :', e)
    return []
  }
}

export async function copyTools(fromPrj: string, toPrj: string) {
  try {
    const result = await axios.post(`/tobject/copy/tools/${fromPrj}/${toPrj}`)
    return result ? result.data : []
  } catch (e) {
    console.log('copyTools failed :', e)
    return []
  }
}

export async function copyToys(toPrj: string) {
  try {
    const result = await axios.post(`/tobject/copy/toys/${toPrj}`)
    return result ? result.data : []
  } catch (e) {
    console.log('copyToys failed :', e)
    return []
  }
}

export async function copyBuffer(fromPrj: string, toPrj: string) {
  try {
    const result = await axios.post(`/buffer/copy/${fromPrj}/${toPrj}`)
    return result ? result.data : []
  } catch (e) {
    console.log('copyBuffer failed :', e)
    return []
  }
}

export async function copyDataset(toPrjId: string) {
  try {
    await axios.post(`/dataset/copy/${toPrjId}`)
    return
  } catch (e) {
    console.log('copyBuffer failed :', e)
    return
  }
}

export async function copyTerminals(fromPrj: string, toPrj: string) {
  try {
    await axios.post(`/term/copy/${fromPrj}/${toPrj}`)
    return
  } catch (e) {
    console.log('copyTerminals failed :', e)
    return
  }
}

export async function copyTestcases(fromPrj: string, toPrj: string) {
  try {
    await axios.post(`/tstcase/copy/${fromPrj}/${toPrj}`)
    return
  } catch (e) {
    console.log('copyTestcases failed :', e)
    return
  }
}

export async function copyTestgoals(fromPrj: string, toPrj: string) {
  try {
    await axios.post(`/tstgoal/copy/${fromPrj}/${toPrj}`)
    return
  } catch (e) {
    console.log('copyTestgoals failed :', e)
    return
  }
}


export async function copyGoalsCases(toPrj: string) {
  try {
    await axios.post(`/goalcase/copy/${toPrj}`)
    return
  } catch (e) {
    console.log('copyGoalsCases failed :', e)
    return
  }
}

export async function copyJobs(fromPrj: string, toPrj: string) {
  try {
    await axios.post(`/job/copy/${fromPrj}/${toPrj}`)
    return
  } catch (e) {
    console.log('copyJobs failed :', e)
    return
  }
}
